import React, { useState } from "react";
import "./ContactUs.css";
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaUser, FaComment } from "react-icons/fa";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thank you for contacting us!");
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <div className="contact-us">
      <h1>Contact Us</h1>
      <p>We'd love to hear from you! Reach out to us using the form below.</p>

      <div className="contact-container">
        {/* Contact Form - Left Side */}
        <form className="contact-form" onSubmit={handleSubmit}>
          <h2>Send us a Message</h2>
          <div className="input-group">
            <FaUser className="icon" />
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-group">
            <FaEnvelope className="icon" />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-group">
            <FaComment className="icon" />
            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>

          <button type="submit" className="submit-btn">Send Message</button>
        </form>

        {/* Contact Details - Right Side */}
        <div className="contact-info">
          <div className="info-card">
            <FaMapMarkerAlt className="icon" />
            <h3>Our Location</h3>
            <p>123 Badminton Street, Sports City</p>
          </div>
          <div className="info-card">
            <FaPhone className="icon" />
            <h3>Call Us</h3>
            <p>+1 234 567 890</p>
          </div>
          <div className="info-card">
            <FaEnvelope className="icon" />
            <h3>Email Us</h3>
            <p>info@badmintontournament.com</p>
          </div>
        </div>
      </div>

      {/* Google Map */}
      <div className="map-container">
        <h2>Find Us on Google Maps</h2>
        <iframe
          title="Google Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.835434509364!2d144.95592831549432!3d-37.8172099797517!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad642af0f11fd81%3A0x5045675218ce6e0!2sFederation%20Square!5e0!3m2!1sen!2sus!4v1623856063211!5m2!1sen!2sus"
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>
    </div>
  );
};

export default ContactUs;
